/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { SocialWebDomainsWidget } from 'schemas/SocialWebDomainsWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import Category from 'enums/Category'
import InsightViewOption from 'enums/InsightViewOption'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { useDashboardData, useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import { toFilter } from '../../../utils/widgetUtil'
import { getWidgetForDashboard } from '../../../features/widget/asyncThunks'
import { createInsightCount } from '../../../utils/runSearchUtil'
import { getMeasureByCountTypeAndAnalysisType } from '../../../utils/measureUtil'
import { getSourceByInsightViewOption } from './Domains/utils'
import { GuardProps } from './types'

function getCategories(widgetSetting: SocialWebDomainsWidget) {
  switch (widgetSetting.viewOption) {
    case InsightViewOption.SUBREDDITS:
      return [Category.SUB_REDDITS]
    case InsightViewOption.BLOGS:
    case InsightViewOption.FORUMS:
    case InsightViewOption.NEWS:
    default:
      return [Category.DOMAINS]
  }
}

const RunSearchEffect = ({ widgetId, children }: GuardProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebDomainsWidget>(widgetId)
  const { id: dashboardId, name } = useDashboardData() as Dashboard
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const filter = toFilter(widgetSetting)
    const sourceType = getSourceByInsightViewOption(widgetSetting.viewOption!)
    if (sourceType) {
      filter.sources = [sourceType]
    }

    const measure = getMeasureByCountTypeAndAnalysisType(
      widgetSetting.countType!,
      widgetSetting.analysisType!
    )

    const search = createInsightCount(
      dashboardId!,
      name!,
      widgetSetting.precision!,
      [widgetSetting.selectedTopic.topicId!],
      filter,
      measure,
      getCategories(widgetSetting)
    )
    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardId, name, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
